import { render, staticRenderFns } from "./TransactionRejectMessage.vue?vue&type=template&id=ac8220a4&"
import script from "./TransactionRejectMessage.vue?vue&type=script&lang=js&"
export * from "./TransactionRejectMessage.vue?vue&type=script&lang=js&"
import style0 from "./TransactionRejectMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports